TvaConfigurationController.$inject = [
	'$scope',
	'$state',
	'$stateParams',
	'$translate',
	'ModalService',
	'TvaConfigurationService',
	'TvaCommunicationService',
	'notification',
	'_',
	'$uibModal',
	'moment'
];

export default function TvaConfigurationController(
	$scope,
	$state,
	$stateParams,
	$translate,
	ModalService,
	TvaConfigurationService,
	TvaCommunicationService,
	notification,
	_,
	$uibModal,
	moment
) {
	const vm = this;

	vm.loading = false;
	vm.isOpen = false;
	vm.params = $stateParams;
	vm.state = $state;
	vm._ = _;
	vm.$uibModal = $uibModal;
	vm.moment = moment;
	vm.tvas = [];

	vm.dateToAdd = vm.moment().startOf('year').format('DD/MM/YYYY');
	vm.loadTvas = loadTvas;
	vm.updateTva = updateTva;
	vm.createTva = createTva;
	vm.deleteTva = deleteTva;
	vm.activeEditMode = activeEditMode;
	vm.desactiveEditMode = desactiveEditMode;
	vm.paysChanged = paysChanged;

	vm.$onInit = async () => {
		vm.unregister = $scope.$watch(
			() => vm.isOpen,
			() => {
				if (vm.isOpen) {
					loadTvas();
				}
			},
			true
		);
		await getPays();
		await getTaux();
		await createTvaByPays();
	};

	vm.$onDestroy = () => {
		vm.unregister();
	};

	async function loadTvas() {
		startLoading();
		try {
			if (vm.id && vm.isOpen) {
				vm.tvas = await TvaConfigurationService.getTvaConfiguration(vm.id, vm.type);
			}
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	function getTvaDefault(pays, achatVente) {
		if (achatVente == 0) {
			let idTvaDefaut = pays.tvas.tvaAchatId;
			if (vm.type == 0 && pays.tvas.tvaProduitAchatId) {
				idTvaDefaut = pays.tvas.tvaProduitAchatId;
			} else if (vm.type == 1 && pays.tvas.tvaPrestationAchatId) {
				idTvaDefaut = pays.tvas.tvaPrestationAchatId;
			} else if (vm.type == 2 && pays.tvas.tvaTransportAchatId) {
				idTvaDefaut = pays.tvas.tvaTransportAchatId;
			}
			return idTvaDefaut;
		} else {
			let idTvaDefaut = pays.tvas.tvaVenteId;
			if (vm.type == 0 && pays.tvas.tvaProduitVenteId) {
				idTvaDefaut = pays.tvas.tvaProduitVenteId;
			} else if (vm.type == 1 && pays.tvas.tvaPrestationVenteId) {
				idTvaDefaut = pays.tvas.tvaPrestationVenteId;
			} else if (vm.type == 2 && pays.tvas.tvaTransportVenteId) {
				idTvaDefaut = pays.tvas.tvaTransportVenteId;
			}
			return idTvaDefaut;
		}
	}

	async function createTvaByPays() {
		vm.tauxPaysVente = [];
		vm.tauxPaysAchat = [];
		vm.pays.forEach((pays) => {
			vm.tauxPaysVente[pays.id] = angular.copy(vm.taux);
			const idTvaDefautVente = getTvaDefault(pays, 1);
			if (idTvaDefautVente) {
				let tva = vm.tauxPaysVente[pays.id].find((t) => t.id == idTvaDefautVente);
				if (tva) {
					tva.defaut = ' [Defaut]';
				}
			}

			vm.tauxPaysAchat[pays.id] = angular.copy(vm.taux);
			const idTvaDefautAchat = getTvaDefault(pays, 0);
			if (idTvaDefautAchat) {
				let tva = vm.tauxPaysAchat[pays.id].find((t) => t.id == idTvaDefautAchat);
				if (tva) {
					tva.defaut = ' [Defaut]';
				}
			}
		});
	}

	async function paysChanged(tva) {
		if (tva) {
			const pays = vm.pays.find((p) => p.id == tva.idPays);
			const idTvaDefautVente = getTvaDefault(pays, 1);
			if (idTvaDefautVente) tva.idTvaVente = idTvaDefautVente;
			const idTvaDefautAchat = getTvaDefault(pays, 0);
			if (idTvaDefautAchat) tva.idTvaAchat = idTvaDefautAchat;
		} else {
			const pays = vm.pays.find((p) => p.id == vm.paysToAdd);
			const idTvaDefautVente = getTvaDefault(pays, 1);
			if (idTvaDefautVente) vm.tvaVenteToAdd = idTvaDefautVente;
			const idTvaDefautAchat = getTvaDefault(pays, 0);
			if (idTvaDefautAchat) vm.tvaAchatToAdd = idTvaDefautAchat;
		}
	}

	async function getPays() {
		startLoading();
		try {
			const res = await TvaConfigurationService.getPays();
			vm.pays = res.items;
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function getTaux() {
		startLoading();
		try {
			vm.taux = await TvaConfigurationService.getTaux();
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function updateTva(tva) {
		const sameCouple = vm.tvas.filter((t) => t.idPays == tva.idPays && t.date == tva.date);
		if (sameCouple && sameCouple.length > 1) {
			notification.error($translate.instant('TVA.DUPLICATE_SAVE'));
			return;
		}
		startLoading();
		try {
			await TvaConfigurationService.updateTvaConfiguration(tva);
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			tva.isEditMode = false;
			vm.tvaIsEditMode = false;
			loadTvas();
			stopLoading();
		}
	}

	async function createTva() {
		if (vm.paysToAdd && vm.dateToAdd && (vm.tvaVenteToAdd || vm.tvaAchatToAdd)) {
			if (vm.tvas.some((tva) => tva.idPays == vm.paysToAdd && tva.date == vm.dateToAdd)) {
				notification.error($translate.instant('TVA.DUPLICATE_SAVE'));
				return;
			}
			startLoading();
			try {
				const data = {
					idPays: vm.paysToAdd,
					idTvaVente: vm.tvaVenteToAdd,
					idTvaAchat: vm.tvaAchatToAdd,
					id: vm.id,
					type: vm.type,
					date: vm.dateToAdd
				};
				await TvaConfigurationService.createTvaConfiguration(data);
			} catch (ex) {
				notification.error(ex.data);
			} finally {
				vm.paysToAdd = null;
				vm.tvaVenteToAdd = null;
				vm.tvaAchatToAdd = null;
				vm.dateToAdd = vm.moment().startOf('year').format('DD/MM/YYYY');
				loadTvas();
				stopLoading();
			}
		} else {
			notification.error($translate.instant('TVA.PAYS_OBLIGATOIRE'));
		}
	}

	async function deleteTva(tva) {
		if (tva) {
			const modalInstance = ModalService.confirm({
				modalTitle: $translate.instant('TVA.DELETE.TITLE', { code: tva.taux }),
				modalMsg: $translate.instant('TVA.DELETE.MESSAGE'),
				headerClass: 'modal-danger'
			});

			modalInstance.result.then(async function () {
				startLoading();
				try {
					await TvaConfigurationService.deleteTvaConfigurationById(tva.idAchat, tva.idVente);
					notification.success($translate.instant('TVA.DELETE.SUCCESS'));
					loadTvas();
				} catch (ex) {
					notification.error(ex.data);
				} finally {
					stopLoading();
				}
			});
		}
	}

	function activeEditMode(tva) {
		tva.isEditMode = true;
		vm.tvaTemp = {
			id: tva.id,
			idPays: tva.idPays,
			idTvaVente: tva.idTvaVente,
			idTvaAchat: tva.idTvaAchat,
			pays: tva.pays,
			date: tva.date,
			tauxVente: tva.tauxVente,
			tauxAchat: tva.tauxAchat
		};
		vm.tvaIsEditMode = true;
	}

	function desactiveEditMode(index, tva) {
		tva.isEditMode = false;
		vm.tvas[index] = vm.tvaTemp;
		vm.tvaIsEditMode = false;
	}

	function startLoading() {
		vm.loading = true;
	}

	function stopLoading() {
		vm.loading = false;
	}
}
